import React, {
  useState,
  useEffect
} from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link as RouterLink,
} from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Breadcrumbs,
  Link,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from '@material-ui/core';
import {
  Skeleton
} from '@material-ui/lab';

import { useStatus } from '../data/Status';

import localization from '../utils/localizations';
import {
  DateTimeView,
  StatusChip,
  SiteWideMessage,
  IssueReportPanel,
} from '../views';

const appConfig = (window as any).APP_CONFIG;


const useStyles = makeStyles((theme) => ({
  mainTable: {
    marginBottom: 20,
  },
  breadcrumbs: {
    margin: 10,
  },
  table: {

  }
}));

function HomePage() {
  const classes = useStyles();
  const [status, statusLoading, loadStatus] = useStatus(false);

  let ugbEnabled = false;
  if (status?.current_ugb_period?.status === 'open') ugbEnabled = true;
  if (status.ugb && status.ugb.id) ugbEnabled = true;
  if (status.student && status.student.can_submit_ugb === false) {
    if (status && status.ugb && !status.ugb.id) {
      ugbEnabled = false;
    }
  }

  let proposalEnabled = false;
  if (status.proposal && status.proposal.id) proposalEnabled = true;

  let thesisEnabled = false;
  if (status.thesis && status.thesis.id) thesisEnabled = true;

  let firstSeminarEnabled = false;
  if (status.first_seminar && status.first_seminar.id) firstSeminarEnabled = true;

  let secondSeminarEnabled = false;
  if (status.second_seminar && status.second_seminar.id) secondSeminarEnabled = true;

  let thesisDefenseEnabled = false;
  if (status.thesis_defense && status.thesis_defense.id) thesisDefenseEnabled = true;

  return (
    <>
    <TableContainer component={Paper} className={classes.mainTable}>
      <Table className={classes.table} aria-label={localization.thesisStage}>
        <TableHead>
          <TableRow>
            <TableCell>{localization.thesisStage}</TableCell>
            <TableCell align="right">{localization.deadline}</TableCell>
            <TableCell align="right">{localization.countdown}</TableCell>
            <TableCell align="right">{localization.status}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              <Button
                variant="contained"
                color="primary"
                to={`${appConfig.homepage}s2/ugb/`}
                component={RouterLink}
                disabled={!ugbEnabled}
              >{localization.ugb}</Button>
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(ugbEnabled && status.current_ugb_period && status.current_ugb_period.end) ? <DateTimeView value={status.current_ugb_period.end} format="DD-MM-YYYY HH:mm:ss" /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(ugbEnabled && status.current_ugb_period && status.current_ugb_period.end) ? <DateTimeView value={status.current_ugb_period.end} fromNow /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {status && status.ugb && status.ugb.status && <StatusChip status={status.ugb.status} size="small" />}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              <Button
              variant="contained"
              color="primary"
              to={`${appConfig.homepage}s2/proposal/`}
              component={RouterLink}
              disabled={!proposalEnabled}
            >{localization.proposal}</Button>
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(proposalEnabled && status.current_ugb_period && status.current_ugb_period.proposal_end) ? <DateTimeView value={status.current_ugb_period.proposal_end} format="DD-MM-YYYY HH:mm:ss" /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(proposalEnabled && status.current_ugb_period && status.current_ugb_period.proposal_end) ? <DateTimeView value={status.current_ugb_period.proposal_end} fromNow /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {status && status.proposal && status.proposal.status && <StatusChip status={status.proposal.status} namespace="proposal" size="small" />}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              <Button
                variant="contained"
                color="primary"
                to={`${appConfig.homepage}s2/tesis/`}
                component={RouterLink}
                disabled={!thesisEnabled}
              >{localization.thesisWriting}</Button>
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(thesisEnabled && status.current_ugb_period && status.current_ugb_period.thesis_writing_end) ? <DateTimeView value={status.current_ugb_period.thesis_writing_end} format="DD-MM-YYYY HH:mm:ss" /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(thesisEnabled && status.current_ugb_period && status.current_ugb_period.thesis_writing_end) ? <DateTimeView value={status.current_ugb_period.thesis_writing_end} fromNow /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {status && status.thesis && status.thesis.status && <StatusChip status={status.thesis.status} size="small" />}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              <Button
                variant="contained"
                color="primary"
                to={`${appConfig.homepage}s2/seminar-1/`}
                component={RouterLink}
                disabled={!firstSeminarEnabled}
              >{localization.firstSeminar}</Button>
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(firstSeminarEnabled && status.current_ugb_period && status.current_ugb_period.first_seminar_end) ? <DateTimeView value={status.current_ugb_period.first_seminar_end} format="DD-MM-YYYY HH:mm:ss" /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(firstSeminarEnabled && status.current_ugb_period && status.current_ugb_period.first_seminar_end) ? <DateTimeView value={status.current_ugb_period.first_seminar_end} fromNow /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {status && status.first_seminar && status.first_seminar.status && <StatusChip status={status.first_seminar.status} size="small" />}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              <Button
                variant="contained"
                color="primary"
                to={`${appConfig.homepage}s2/seminar-2/`}
                component={RouterLink}
                disabled={!secondSeminarEnabled}
              >{localization.secondSeminar}</Button>
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(secondSeminarEnabled && status.current_ugb_period && status.current_ugb_period.second_seminar_end) ? <DateTimeView value={status.current_ugb_period.second_seminar_end} format="DD-MM-YYYY HH:mm:ss" /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(secondSeminarEnabled && status.current_ugb_period && status.current_ugb_period.second_seminar_end) ? <DateTimeView value={status.current_ugb_period.second_seminar_end} fromNow /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {status && status.second_seminar && status.second_seminar.status && <StatusChip status={status.second_seminar.status} size="small" />}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              <Button
                variant="contained"
                color="primary"
                to={`${appConfig.homepage}s2/sidang/`}
                component={RouterLink}
                disabled={!thesisDefenseEnabled}
              >{localization.thesisDefense}</Button>
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(thesisDefenseEnabled && status.current_ugb_period && status.current_ugb_period.thesis_defense_end) ? <DateTimeView value={status.current_ugb_period.thesis_defense_end} format="DD-MM-YYYY HH:mm:ss" /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {!status.success ? (
                <Skeleton variant="rect" width={'100%'} height={20} />
              ) : (
                <Typography>{(thesisDefenseEnabled && status.current_ugb_period && status.current_ugb_period.thesis_defense_end) ? <DateTimeView value={status.current_ugb_period.thesis_defense_end} fromNow /> : '-'}</Typography>
              )}
            </TableCell>
            <TableCell align="right">
              {status && status.thesis_defense && status.thesis_defense.status && <StatusChip status={status.thesis_defense.status} size="small" />}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>

    <SiteWideMessage />

    <IssueReportPanel />
    </>
  );
}

export default HomePage;